import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, of } from 'rxjs';
import { AppState } from '../app.service';
import { switchMap } from 'rxjs/operators';
import { SessionService } from '../_services/session/session.service';
import { ConfigService } from '../_services/config/config.service';
import { BootstrapProduct } from '../_utilities';

@Component({
  selector: 'pq-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./_sso.component.scss']
})
export class SsoComponent {
  public hasError: boolean = false;

  private ssoType: string;
  private _ssoProviders: object = {
    clever: {
      sessionName: 'code',
      sessionStateName: 'state'
    },
    google: {
      sessionName: 'code',
      sessionStateName: 'state'
    },
    shibboleth: {
      shibbolethParameters: 'shibbolethParameters'
    }
  };

  constructor (
    private _appState: AppState,
    private _sessionSvc: SessionService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _bootstrapProduct: BootstrapProduct,
    private _configSvc: ConfigService
  ) {
    // this may show as being deprecated in the IDE but is the latest format according to the rxjs
    // https://github.com/ReactiveX/rxjs/issues/3618
    combineLatest(this._route.paramMap, this._route.queryParamMap)
      .pipe(
        switchMap(([params, queryParams]) => {
          this.ssoType = params.get('ssotype');
          const ssoConfig = this._ssoProviders[this.ssoType];

          if (this.ssoType === 'clever') {
            this._appState.set({ clever: { code: queryParams.get(ssoConfig['sessionName']), state: queryParams.get(ssoConfig['sessionStateName']) }});
          } else if (this.ssoType === 'google') {
            this._appState.set({ google: { code: queryParams.get(ssoConfig['sessionName']), state: queryParams.get(ssoConfig['sessionStateName']) }});
          } else if (this.ssoType === 'shibboleth') {

            // shibbolethParameters=JeYL+n1imWj5q0vr5xg7fAUlZSZ0vTlsJgFSq6nrb4QYqeE3XKe5b/iXdyM1yLyNqseYoLNqs50KUiiK8508h15M/LlUo5zM+k22+XuCsxI5UzDmj2HOhAJXN5LIbGdEYafXaPevUfVH/0RMucesoCEyctb9Y6+NPVp2ioDXWJOLGOLmfi77AE1ciZEuU11/
            this._appState.set({ shibboleth: { shibbolethParameters: queryParams.get(ssoConfig['shibbolethParameters'])}})
          }

          return this._sessionSvc.loggedInCheck();
        }),
        switchMap((isLoggedIn: boolean) => {

          if (isLoggedIn) {
            return this._configSvc.get()
          }

          this._doRedirect('login', { sso: this.ssoType + 'auth', error: true });

          return of(undefined );
        }),
        switchMap((configResp: object) => {
          if (configResp) {
            this._appState.set(configResp);

            return this._bootstrapProduct.executeLoad();
          }

          return of({ completed: true });
        })
      )
      .subscribe((loadResp) => {
        if (loadResp['completed'] === true && loadResp['status'] === 'successful') {
          this._doRedirect('home');
          this.hasError = false;
        } else if (loadResp['completed'] === true && loadResp['status'] === 'error') {
          this.hasError = true;
        }
    });
  }

  private _doRedirect (location: string, queryParams: object = {}): void  {
    const profile = this._appState.get('current_profile');
    const commands = profile ? ['/', profile, location] : ['/', location];

    this._router.navigate(commands,  { replaceUrl: true, queryParams });
  }
}
